import { getData } from 'src/services/RestApi';
import { formatCode, formatPhone } from 'src/utils/formatters';
const TypeChecker = require('src/utils/type-checker');

const getMyOrderWorking = async () => {
  if(true){
    // Cheat code for hide feature
    return [];
  }
  const { result, error } = await getData('api/order/my/working');
  if(error){
    return [];
  }
  result.forEach(element => {
    element.teacherCode = formatCode(element.teacherCode);
    element.studentCode = formatCode(element.studentCode);
    element.studentPhone = formatPhone(element.studentPhone);
  });
  return result;
};

export { getMyOrderWorking };
